import { render, staticRenderFns } from "./PressReleasesSingle.vue?vue&type=template&id=7f4fcc54&scoped=true&"
import script from "./PressReleasesSingle.vue?vue&type=script&lang=js&"
export * from "./PressReleasesSingle.vue?vue&type=script&lang=js&"
import style0 from "./PressReleasesSingle.vue?vue&type=style&index=0&id=7f4fcc54&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4fcc54",
  null
  
)

export default component.exports